import { render } from "./CardUnidade.vue?vue&type=template&id=7ada6b34&scoped=true"
import script from "./CardUnidade.vue?vue&type=script&lang=js"
export * from "./CardUnidade.vue?vue&type=script&lang=js"

import "./CardUnidade.vue?vue&type=style&index=0&id=7ada6b34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ada6b34"]])

export default __exports__